import { render, staticRenderFns } from "./AreYouThereBrotherZeki.vue?vue&type=template&id=4ed11227&scoped=true&lang=pug&"
import script from "./AreYouThereBrotherZeki.vue?vue&type=script&lang=js&"
export * from "./AreYouThereBrotherZeki.vue?vue&type=script&lang=js&"
import style0 from "./AreYouThereBrotherZeki.vue?vue&type=style&index=0&id=4ed11227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed11227",
  null
  
)

export default component.exports